import axios from 'axios';



export const getOtp = async (phone) => {
    try {
        // const response = await axios.post("https://asia-south1-equentis-uat-env.cloudfunctions.net/iir-landing-page/request-otp", {
        //     mobile: `${phone}` // Axios automatically stringifies this and sets JSON headers
        // });

        const response = await axios.post("https://asia-south1-equentis-prod-env.cloudfunctions.net/iir-landing-page/request-otp", {
            mobile: `${phone}` // Axios automatically stringifies this and sets JSON headers
        });

        // Axios puts the server response body inside the 'data' property
        return response.data;
    } catch (error) {
        // Axios error handling is more detailed than fetch
        console.error("Error fetching OTP:", error.response?.data || error.message);
        throw error;
    }
}